import axios from './../http'

function query() {
    return axios.get('/sys/menu/query');
}

function save(data) {
    return axios.post('/sys/menu/save', data);
}

function get(id) {
    return axios.get('/sys/menu/get?menuId=' + id);
}

function select() {
    return axios.get('/sys/menu/select');
}

function navigate() {
    return axios.get('/sys/menu/navigate');
}

function valid(data) {
    return axios.post('/sys/menu/valid', data);
}
function invalid(data) {
    return axios.post('/sys/menu/invalid' , data);
}

function findByUsedBy(usedBy) {
    return axios.get('/sys/menu/findByUsedBy?usedBy='+usedBy);
}


export default {
    query,
    select,
    get,
    save,
    valid,
    invalid,
    navigate,
    findByUsedBy
}